export default __webpack_public_path__ + "static/media/project.aa159f66.png";